const formatters = () => {
    const usCurrencyFormatter = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    });

    const numberFormatter = Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
    });

    const percentFormatter = Intl.NumberFormat('en-US', {
        style: 'percent',
        maximumFractionDigits: 0,
    });

    const camelToTitleCase = (str) => {
        return str.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase()).trim(); 
    }

    const toTitleCase = (str) => {
        if (str){
            str = str?.toLowerCase()?.split(' ')?.map((word) => {return word[0] ? word.replace(word[0], word[0].toUpperCase()): word[0]});
            return str?.join(' ');  
        }
    }

    const camelCaseToUnderscore = (str) => {
        return str.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '');
    }

    return {
        usCurrencyFormatter,
        numberFormatter,
        percentFormatter, 
        camelToTitleCase,
        toTitleCase,
        camelCaseToUnderscore
    };
}

export default formatters;